.index {
  border-radius: 64px;
  border: 2px solid var(--primary-100);
  background-color: var(--color-ffffff);
  color: var(--primary-100);
  font-size: 1.2rem;
  padding: 5px 12px;
}

.title {
  color: var(--text);
  margin-left: 10px;
  font-size: 1.5rem;
  font-family: "Bree", sans-serif;
  font-weight: 400;
}

.borderLeft {
  border-left: 2px solid var(--text);
  margin-left: 17px;
  min-height: 30px;
}

.open {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  padding: 30px;
  color: var(--text);
  margin: 15px 0;
  font-size: 1.1rem;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.container > * {
  flex: 0 0 100%;
}

.active {
  border: 2px solid var(--color-ffffff);
  background-color: var(--primary-100);
  color: var(--color-ffffff);
}

.navigation {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 10px 0;
}

.align {
  display: flex;
  align-items: center;
}

.nok {
  color: red;
}

.ok {
  color: green;
}
